const fontSizeRatio = 1.8;

export class TextResizerModule {
    initialize() {
        document.querySelectorAll('.text-resizer').forEach(element => new TextResizer(element));
    }
}

class TextResizer {
    constructor(element) {
        this.element = element;
        this.textElement = element.querySelector('h1, h2, h3, h4, h5, h6, p');
        this.letterCount = this.textElement?.textContent.length || 0;

        this.resize();
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        const { paddingLeft, paddingRight, paddingTop, paddingBottom } = window.getComputedStyle(this.element);

        const containerWidth = this.element.clientWidth - (parseFloat(paddingLeft) + parseFloat(paddingRight));
        const containerHeight = this.element.clientHeight - (parseFloat(paddingTop) + parseFloat(paddingBottom));
        const containerArea = containerWidth * containerHeight;

        if (this.letterCount > 0 && containerArea > 0) {
            const fontSize = Math.sqrt(containerArea / this.letterCount) / fontSizeRatio;
            this.textElement.style.fontSize = `${fontSize}px`;
        }
    }
}